import { createActionBundle } from 'utilities/request';

export const {
  request: requestReports,
  success: requestReportsSuccess,
  failure: requestReportsFailure,
} = createActionBundle('REPORTS');
